import { 
  Box, 
  Typography, 
  Grid, 
  CardMedia, 
  CardContent, 
  Container,
  Card,
  Button
} from '@mui/material';
import { cardMixins, typographyMixins, buttonMixins } from '../styles/mixins';

function Registry() {
  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Box sx={{ mb: 6 }}>
        <Typography 
          variant="h4" 
          component="h1"
          sx={typographyMixins.pageTitle}
        >
          Wedding Registry
        </Typography>
        
        <Typography
          variant="body1"
          sx={typographyMixins.centeredBodyText}
        >
          Your presence is the greatest gift of all, but if you'd like to help us build our future, we've set up funds for our honeymoon and home renovations.
        </Typography>

        <Grid container spacing={4}>
          {/* Honeymoon Fund Card */}
          <Grid item xs={12} md={6}>
            <Card sx={cardMixins.cardWithButton}>
              <CardMedia
                component="img"
                height="300"
                image="/honeymoon_fund.png"
                alt="Airplane wing over mountains"
                sx={cardMixins.cardMedia}
              />
              <CardContent sx={cardMixins.cardContent}>
                <Typography 
                  variant="h5" 
                  component="h2" 
                  sx={typographyMixins.sectionTitle}
                >
                  Honeymoon Fund
                </Typography>
                
                <Typography paragraph sx={typographyMixins.bodyText}>
                  Help us fund our dream vacation!
                </Typography>
                
                <Typography paragraph sx={typographyMixins.bodyText}>
                  We are trying to decide between:
                </Typography>
                
                <Box sx={{ pl: 2, mb: 2 }}>
                  <Typography sx={{ mb: 1, display: 'flex' }}>
                    <Box component="span" sx={{ mr: 1 }}>•</Box>
                    A road trip around New Zealand
                  </Typography>
                  <Typography sx={{ mb: 1, display: 'flex' }}>
                    <Box component="span" sx={{ mr: 1 }}>•</Box>
                    Pura Vida in Costa Rica
                  </Typography>
                </Box>
                
                <Typography paragraph sx={{ ...typographyMixins.bodyText, mb: 3 }}>
                  Tell us your favorite idea in the comments!
                </Typography>
                
                <Box sx={cardMixins.cardButtonContainer}>
                  <Button
                    variant="contained"
                    component="a"
                    href="https://www.zola.com/registry/samandalexaaugust2"
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={buttonMixins.wideButton}
                  >
                    Contribute to our Honeymoon Fund
                  </Button>
                </Box>
              </CardContent>
            </Card>
          </Grid>

          {/* Bathroom Fund Card */}
          <Grid item xs={12} md={6}>
            <Card sx={cardMixins.cardWithButton}>
              <CardMedia
                component="img"
                height="300"
                image="/bathroom_fund.png"
                alt="Bathroom renovation"
                sx={cardMixins.cardMedia}
              />
              <CardContent sx={cardMixins.cardContent}>
                <Typography 
                  variant="h5" 
                  component="h2" 
                  sx={typographyMixins.sectionTitle}
                >
                  Bathroom/Laundry Room Renovation Fund
                </Typography>
                
                <Typography paragraph sx={typographyMixins.bodyText}>
                  You've all heard us talk about how awful our downstairs bathroom "situation" is. If you've been to our house, you've seen the chaos.
                </Typography>
                
                <Typography paragraph sx={typographyMixins.bodyText}>
                  It's really starting to fall apart these days. We've got mold, unfinished everything, it's cold, and there are spiders everywhere.
                </Typography>
                
                <Typography paragraph sx={{ ...typographyMixins.bodyText, mb: 3 }}>
                  Help us fund a bathroom renovation!
                </Typography>
                
                <Box sx={cardMixins.cardButtonContainer}>
                  <Button
                    variant="contained"
                    component="a"
                    href="https://www.zola.com/registry/samandalexaaugust2"
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={buttonMixins.wideButton}
                  >
                    Contribute to our Renovation Fund
                  </Button>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
}

export default Registry;
